import type {AxiosRequestConfig} from 'axios';
import {DriverShift} from './interface';

export class DeleteDriverShiftBuilder {
  private readonly driverShiftRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.driverShiftRequest.url = `/driver-shifts/${id}`;
    return this;
  }
  build() {
    return this.driverShiftRequest;
  }
}
export class GetAllDriverShiftsRequestBuilder {
  private readonly driverShiftRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/driver-shifts',
    params: {},
  };

  id(id: number) {
    this.driverShiftRequest.url = `/driver-shifts/${id}`;
    return this;
  }

  pageNumber(num: number) {
    this.driverShiftRequest.params.pageNumber = num;
    return this;
  }
  pageSize(num: number) {
    this.driverShiftRequest.params.pageSize = num;
    return this;
  }
  paged(paged: boolean) {
    this.driverShiftRequest.params.paged = paged;
    return this;
  }

  build() {
    return this.driverShiftRequest;
  }
}
export class GetDriverShiftsCountRequestBuilder {
  private readonly driverShiftRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/driver-shifts/count',
  };

  build() {
    return this.driverShiftRequest;
  }
}

export class CreateDriverShiftRequestBuilder {
  private readonly driverShiftRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/driver-shifts',
    data: {},
  };

  data(data: DriverShift) {
    this.driverShiftRequest.data = data;
    return this;
  }

  build() {
    return this.driverShiftRequest;
  }
}

export class UpdateDriverShiftRequestBuilder {
  private readonly driverShiftRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/driver-shifts',
    data: {},
  };
  data(body: DriverShift) {
    this.driverShiftRequest.data = body;
    return this;
  }
  build() {
    return this.driverShiftRequest;
  }
}

export class CreateDriversShiftRequestBuilder {
  private readonly driverShiftRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/drivers',
    data: {},
  };
  id(id: number) {
    this.driverShiftRequest.url = `/drivers/${id}/shifts`;
    return this;
  }
  data(body: DriverShift) {
    this.driverShiftRequest.data = body;
    return this;
  }
  build() {
    return this.driverShiftRequest;
  }
}
